<template>
  <div>
    <v-menu
      top offset-y right
      min-width="150"
    >
      <template #activator="{ on }">
        <v-btn
          color="grey400" class="px-3 text-none rounded-0 text-caption"
          :ripple="false" small v-on="on"
        >
          <span v-if="roomFlag" class="twf mr-1" :class="`twf-${roomFlag}`" />
          <span v-t="`layout.chat.room.${room}`" class="mr-1" />
          <fai :icon="['far', 'angle-down']" />
        </v-btn>
      </template>

      <v-list color="grey600" class="py-0 rounded-0" dense>
        <v-list-item
          v-for="option in options"
          :key="option.id"
          :ripple="false"
          class="lang-item"
          :class="{ active: room === option.id }"
          @click="onListItemClick(option.id)"
        >
          <v-list-item-title class="d-flex align-center text--secondary">
            <span v-if="option.flag" class="twf mr-2" :class="`twf-${option.flag}`" />
            <span v-t="`layout.chat.room.${option.id}`" class="text-body-2" />
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { TO_FLAG } from '@/utils/i18n'

export default {
  props: {
    room: {
      type: String,
      default: null,
    },
    rooms: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    options() {
      return this.rooms.map(room => {
        const isLangRoom = room.startsWith('lang-')
        const lang = room.replace('lang-', '')

        return {
          id: room,
          flag: isLangRoom ? TO_FLAG[lang] ?? lang : null,
        }
      })
    },
    roomFlag() {
      if (!this.room) return null
      const isLangRoom = this.room.startsWith('lang-')
      const lang = this.room.replace('lang-', '')

      return isLangRoom ? TO_FLAG[lang] ?? lang : null
    },
  },
  methods: {
    onListItemClick(room) {
      if (this.room === room) return

      this.$emit('change', room)
    },
  },
}
</script>

<style lang="scss" scoped>
.lang-item {
  .twf {
    width: 1.75em;
    height: 1.75em;
    vertical-align: -0.5em;
  }

  &.active .text-body-2 {
    color: grey(100);
  }
}

</style>
